export function safeJsonResponse(data: any, wrapWithComment = false) {
  // Always return an object, even for array responses
  const safeData = { response: data };

  if (wrapWithComment) {
    return `/* ${JSON.stringify(safeData)} */`;
  }

  return (safeData);
}

export async function fetchSafeJson(data: any) {
  let response;
  if (data.startsWith("/*") && data.endsWith("*/")) {
    // Remove comment from response
    data = await data.slice(2, -2).trim();
  }
  response = await JSON.parse(data);
  return await response;
}
